import React, { useEffect, useRef, useState } from "react";
import share from "../../../Assets/Images/share.svg";
import { Button } from "Components/ui/button";
import { Clipboard, Download } from "lucide-react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Dialog, DialogContent, DialogTitle } from "Components/ui/dialog";
import { Separator } from "Components/ui/separator";
import { toast } from "sonner";
import CapitalCertificate from "./CapitalCertificate";
import WithdrawCertificate from "./WithdrawCertificate";
import BronzeCertificate from "./BronzeCertificate";
import SilverCertificate from "./SilverCertificate";
import GoldCertificate from "./GoldCertificate";
import PlatCertificate from "./PlatCertificate";
import { format } from "date-fns";
import { Skeleton } from "Components/ui/skeleton";

function CertificateCard({
  certificateName,
  link,
  setImageSingle,
  found,
  userName,
  date,
  amount,
  stage,
  displayName,
  onlyImage,
}) {
  const [image, setImage] = useState(null);
  const [go, setGo] = useState(false);
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  const handleDownloadPDF = () => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: [400, 400], // Ensures no white space
    });
    doc.addImage(image, "PNG", 0, 0, 400, 400);
    doc.save("certificate.pdf");
  };

  useEffect(() => {
    if (go)
      if (ref.current) {
        html2canvas(ref.current, {
          scale: 2,
          quality: 1,
        }).then((canvas) => {
          setImageSingle && setImageSingle(canvas.toDataURL("image/png"));
          setImage(canvas.toDataURL("image/png"));
        });
      }
  }, [go]);

  return (
    <div
      className={`${found ? "opacity-100" : "opacity-50"} ${
        onlyImage
          ? "bg-background-secondary md:p-6 p-0  rounded-xl"
          : "bg-background-secondary p-6 rounded-xl"
      }`}
    >
      {image ? (
        <img src={image} className="w-full h-auto aspect-square " />
      ) : certificateName === "capital" ? (
        <>
          <div
            className="absolute top-[-100000rem] left-[-10000000rem]"
            ref={ref}
          >
            <CapitalCertificate
              style={{
                width: "100%",
                height: "auto",
                aspectRatio: "1/1",
              }}
              name={userName}
              date={date}
              found={found}
              amount={amount}
              Stage={stage}
              link={link}
              setGo={setGo}
            />
          </div>
          <div className="w-full">
            <Skeleton className={"w-full !aspect-square"} />
          </div>
        </>
      ) : certificateName === "withdraw" ? (
        <>
          <div
            className="absolute top-[-100000rem] left-[-10000000rem]"
            ref={ref}
          >
            <WithdrawCertificate
              style={{
                width: "100%",
                height: "auto",
                aspectRatio: "1/1",
              }}
              name={userName}
              date={date}
              found={found}
              amount={amount}
              link={link}
              setGo={setGo}
            />
          </div>{" "}
          <div className="w-full">
            <Skeleton className={"w-full !aspect-square"} />
          </div>
        </>
      ) : certificateName === "bronze" ? (
        <>
          <div
            className="absolute top-[-100000rem] left-[-10000000rem]"
            ref={ref}
          >
            <BronzeCertificate
              style={{
                width: "100%",
                height: "auto",
                aspectRatio: "1/1",
              }}
              name={userName}
              date={date}
              found={found}
              amount={amount}
              link={link}
              setGo={setGo}
            />
          </div>
          <div className="w-full">
            <Skeleton className={"w-full !aspect-square"} />
          </div>
        </>
      ) : certificateName === "silver" ? (
        <>
          <div
            className="absolute top-[-100000rem] left-[-10000000rem]"
            ref={ref}
          >
            <SilverCertificate
              style={{
                width: "100%",
                height: "auto",
                aspectRatio: "1/1",
              }}
              name={userName}
              date={date}
              found={found}
              amount={amount}
              link={link}
              setGo={setGo}
            />
          </div>
          <div className="w-full">
            <Skeleton className={"w-full !aspect-square"} />
          </div>
        </>
      ) : certificateName === "gold" ? (
        <>
          <div
            className="absolute top-[-100000rem] left-[-10000000rem]"
            ref={ref}
          >
            <GoldCertificate
              style={{
                width: "100%",
                height: "auto",
                aspectRatio: "1/1",
              }}
              name={userName}
              date={date}
              found={found}
              amount={amount}
              link={link}
              setGo={setGo}
            />
          </div>
          <div className="w-full">
            <Skeleton className={"w-full !aspect-square"} />
          </div>
        </>
      ) : (
        certificateName === "platinum" && (
          <>
            <div
              className="absolute top-[-100000rem] left-[-10000000rem]"
              ref={ref}
            >
              <PlatCertificate
                style={{
                  width: "100%",
                  height: "auto",
                  aspectRatio: "1/1",
                }}
                name={userName}
                date={date}
                found={found}
                amount={amount}
                link={link}
                setGo={setGo}
              />
            </div>
            <div className="w-full">
              <Skeleton className={"w-full !aspect-square"} />
            </div>
          </>
        )
      )}

      {!onlyImage && (
        <>
          <div className="flex flex-row items-center justify-between gap-4 mt-4">
            <div>
              <div>
                <div className="font-N_Bold text-lg">{displayName}</div>
              </div>
              <div className="font-N_Light text-white-opacity text-sm">
                {found && !isNaN(new Date(date).getTime())
                  ? format(new Date(date), "dd MMMM, yyyy")
                  : "Not Obtained Yet!"}
              </div>
            </div>
            <img
              src={share}
              alt="share"
              className={`${
                found ? "cursor-pointer" : "cursor-not-allowed"
              } scale-[1.1]`}
              onClick={() => {
                found && setOpen(!open);
              }}
            />
          </div>
          <div className="flex flex-row gap-4 justify-between mt-4">
            <Button
              variant="outline"
              className={`flex-1 p-0 font-N_Medium text-sm ${
                found ? "" : "cursor-not-allowed"
              }`}
              onClick={() => {
                found && handleDownloadPDF();
              }}
            >
              <Download />
              Download PDF
            </Button>
            <Button
              variant="outline"
              className={`flex-1 p-0 font-N_Medium text-sm ${
                found ? "" : "cursor-not-allowed"
              }`}
              onClick={() => {
                if (found) {
                  const a = document.createElement("a");
                  a.href = image;
                  a.download = "certificate.png";
                  a.click();
                }
              }}
            >
              <Download />
              Download Image
            </Button>
          </div>
        </>
      )}
      <Dialog open={open} onOpenChange={() => setOpen(!open)}>
        <DialogContent className="p-0">
          <DialogTitle className="p-6 pb-0">Sharing</DialogTitle>
          <Separator />
          <div className="p-6 pt-0 flex flex-col gap-4">
            <div>
              This page is private. You can publicly share it with other traders
              using link below.
            </div>

            <div className="w-full border border-border px-4 py-2 rounded-lg flex flex-row justify-between items-center">
              <div className="truncate w-[25rem]">{link}</div>
              <Clipboard
                color="var(--primary)"
                className="cursor-pointer"
                onClick={() => {
                  navigator.clipboard.writeText(link);
                  toast.success("Link copied to clipboard");
                  setTimeout(() => {
                    setOpen(false);
                  }, 2000);
                }}
              />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default CertificateCard;
